import { useEffect, useState } from "react";
import { useApiCall } from "../../component/custom-hooks/api-call";
import { Alert, Snackbar } from "@mui/material";
import AddDealPackage from "../dealDemo/add-form";
import PlusIcon from "../../component/icons/plus";
import InnerLoader from "../../component/ui/loader/inner-loader";


export default function LeadPackagesPricingSection() {
    const [packages, setPackages] = useState([]);
    const [packageId, setPackageId] = useState({});
    const [isPackagesLoaded, setIsPackagesLoaded] = useState(false);
    const [showAddDealPackage, setShowAddDealPackage] = useState(false);
    const [addLead, setAddLead] = useState(false);
    const [alertData, setAlertData] = useState({ isShow: false });

    const handleClose = () => {
        setAlertData({ isShow: false });
    };

    const apiCall = useApiCall();

    const getPackagesList = async () => {
        setIsPackagesLoaded(false);

        try {
            const resp = await apiCall({
                method: "get",
                url: "packages/packages-list",
            });

            // console.log("Packages Response:", resp);

            if (resp?.status) {
                const visiblePackages = resp.data.filter(
                    (pkg) => pkg.show_pkg === 1
                );

                setPackages(visiblePackages);
            }

            setIsPackagesLoaded(true);
        } catch (error) {
            console.warn("Packages API Error:", error);
            setIsPackagesLoaded(true);
        }
    };

    useEffect(() => {
        getPackagesList();
    }, []);


    const onSuccess = (message) => {
        setAlertData({ isShow: true, type: "success", message: message });
        setShowAddDealPackage(false);
        window.location.reload();
    };

    const onError = (message) => {
        setAlertData({ isShow: true, type: "error", message: message });
    };

    return (
        <>
            {!isPackagesLoaded ? (
                <div className="h-screen w-screen flex items-center justify-center">
                    <InnerLoader />
                </div>
            ) : (
                <>
                    <div className="p-7 h-screen w-screen flex flex-col overflow-y-auto">
                        <div className="mx-auto">
                            <div className="text-center mb-12">
                                <h2 className="text-[40px] font-bold text-[#0f172a]">
                                    Choose your plan
                                </h2>
                                <p className="text-gray-500 mt-2 text-[16px]">
                                    Affordable for everyone
                                </p>

                                <div className="flex items-end justify-end">
                                    <div
                                        className={`
                        bg-[linear-gradient(92deg,#0057FB_1.54%,#003495_114.12%)] 
                        hover:bg-[linear-gradient(92deg,#0066FF_1.54%,#0045AA_114.12%)]
                        
                        py-[10px] px-[12px] rounded-[5px] text-center 
                        text-[#fff] text-[12px] font-semibold text-nowrap 
                        flex items-center justify-center transition-all
                        gap-1
                        cursor-pointer
                      `}
                                        onClick={() => {
                                            setAddLead(true);
                                        }}
                                    >
                                        <PlusIcon />
                                        Add Simple Lead
                                    </div>
                                </div>
                            </div>
                            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                                {packages.map((pkg) => (
                                    <div
                                        key={pkg.packageid}
                                        className="bg-white rounded-2xl p-8 border border-gray-200 shadow-sm"
                                    >
                                        <h3 className="text-[22px] font-semibold text-[#0f172a]">
                                            {pkg.packagename}
                                        </h3>

                                        <p className="text-gray-500 mt-1 text-[14px]">
                                            {pkg.tagline}
                                        </p>

                                        <div className="mt-6 flex items-end">
                                            <span className="text-[14px] mr-1">$</span>
                                            <span className="text-[48px] font-bold text-[#0f172a]">
                                                {pkg.amount}
                                            </span>
                                            <span className="text-gray-500 ml-2 mb-2">
                                                /package
                                            </span>
                                        </div>

                                        {pkg.oldprice > 0 && (
                                            <p className="text-gray-400 line-through mt-1">
                                                ${pkg.oldprice}
                                            </p>
                                        )}

                                        <button className="w-full mt-6 bg-[#3b9c83] text-white py-3 rounded-lg font-medium"
                                            onClick={() => {
                                                setShowAddDealPackage(true);
                                                setPackageId({ packageId: pkg?.packageid, packageName: pkg?.packagename, })
                                            }}
                                        >
                                            Order Now
                                        </button>

                                        <div className="mt-6 text-[14px] text-gray-700 space-y-2">
                                            {pkg.features?.includes("<ul") ? (
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: pkg.features,
                                                    }}
                                                />
                                            ) : (
                                                pkg.features
                                                    ?.split("\n")
                                                    .map((feature, index) => (
                                                        <div key={index}>
                                                            {feature.trim()}
                                                        </div>
                                                    ))
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div >
                    {showAddDealPackage && (
                        <AddDealPackage
                            onClose={() => {
                                setTimeout(() => {
                                    setShowAddDealPackage(false);
                                }, 200);
                            }}
                            fromPackage={true}
                            onSubmit={onSuccess}
                            onError={onError}
                            packageId={packageId?.packageId}
                            packageName={packageId?.packageName}

                        />
                    )
                    }

                    {addLead && (
                        <AddDealPackage
                            onClose={() => {
                                setTimeout(() => {
                                    setAddLead(false);
                                }, 200);
                            }}
                            onSubmit={onSuccess}
                            onError={onError}
                        />
                    )
                    }
                    <Snackbar
                        open={alertData?.isShow}
                        autoHideDuration={3000}
                        onClose={handleClose}
                    >
                        <Alert
                            onClose={handleClose}
                            severity={alertData?.type}
                            variant="filled"
                            sx={{ width: "100%" }}
                        >
                            {alertData?.message}
                        </Alert>
                    </Snackbar>
                </>
            )}
        </>
    );
}